import request from "../utils/request";
import { APP_API_BASE_URL } from "../utils/env"
const userApi = {
  Login: APP_API_BASE_URL + "session",
  LoginCode: APP_API_BASE_URL + 'v4/session/phone',
  IM_TOKEN: APP_API_BASE_URL + '/user/im/token',
  ShiftList: "/session/shift",
  ShiftListV2: "/session/v2/shift",
}

export function loginApi(parameter) {
  const { tenant } = parameter;
  delete parameter.tenant;
  return request({
    url: userApi.Login,
    method: "post",
    data: parameter,
    withoutToken: true,
    withoutHeaders: true,
    headers: tenant ? {
      tenant
    } : {}
  })
}
export function loginCodeApi(parameter) {
  const { tenant, code, phone } = parameter;
  delete parameter.code;
  delete parameter.phone;
  delete parameter.tenant;
  return request({
    url: userApi.LoginCode,
    method: "post",
    params: {
      code, phone
    },
    data: parameter,
    withoutToken: true,
    withoutHeaders: true,
    headers: tenant ? {
      tenant
    } : {}
  })
}

export function getShiftListApi() {
  return request({
    url: userApi.ShiftList,
    method: "get"
  })
}

export function getShiftListV2Api() {
  return request({
    url: userApi.ShiftListV2,
    method: "get"
  })
}

export function getImTokenApi() {
  return request({
    url: userApi.IM_TOKEN,
    method: "get"
  })
}

export function updateAddress() {
  return request({
    url: userApi.USER_IMPORT,
    method: 'post',
  })
}
